module.exports = {"title":"Upgrade your vehicle and receive a {voucher} valued at {type, select, variable {up to} other {}}"}